@if (o | async; as items) {
	@if (items.length > 0) {
		<mat-toolbar class="mep-breadcrumb">
			<a routerLink="/homescreen" class="">
				<mat-icon class="mep-icon-small-white material-symbols-rounded">home</mat-icon>
			</a>
			@for (item of items; track item; let i = $index) {
				<mat-icon class="mep-icon-small-white me-6" matSuffix>keyboard_arrow_right</mat-icon>
				@if (
					items.length === 2 &&
						i === 1 &&
						(items[1].text === 'project-details' ||
							items[1].text === 'employee-edit' ||
							items[1].text === 'resource-request-details' ||
							items[1].text === 'action-plan' ||
							items[1].text === 'my-profiles')
				) {
					<ng-container *appRequiresPermission="'READ_BU'; entity: 'EMPLOYEE'">
						@if (items[1].text === 'employee-edit') {
							<app-breadcrumb-emp-search
								class="navigationLink search-container"
								[breadcrumb]="item"
							>
							</app-breadcrumb-emp-search>
						}
					</ng-container>

					<ng-container *appRequiresPermission="'READ_BU'; entity: 'PROJECT'">
						@if (items[1].text === 'project-details') {
							<app-breadcrumb-project-search
								class="navigationLink search-container"
								[breadcrumb]="item"
							>
							</app-breadcrumb-project-search>
						}
					</ng-container>

					<ng-container *appRequiresPermission="'READ'; entity: 'RESOURCE_REQUEST'">
						@if (items[1].text === 'resource-request-details') {
							<app-breadcrumb-resource-request-search
								class="navigationLink search-container"
								[breadcrumb]="item"
							>
							</app-breadcrumb-resource-request-search>
						}
					</ng-container>

					<ng-container *appRequiresPermission="'READ_BU'; entity: 'EMPLOYEE'">
						@if (items[1].text === 'my-profiles') {
							<app-breadcrumb-profile-search
								class="navigationLink search-container"
								[breadcrumb]="item"
							>
							</app-breadcrumb-profile-search>
						}
					</ng-container>

					@if (inDetails) {
						<button
							mat-mini-fab
							color="accent"
							class="navigationArrow"
							(click)="navigateToPreviousDetail()"
							[ngClass]="{'navigationArrow-disabled': disablePreviousButton}"
						>
							<mat-icon>arrow_upward</mat-icon>
						</button>
					}
					@if (inDetails) {
						<button
							mat-mini-fab
							color="primary"
							class="navigationArrow"
							(click)="navigateToNextDetail()"
							[ngClass]="{'navigationArrow-disabled': disableNextButton}"
						>
							<mat-icon>arrow_downward</mat-icon>
						</button>
					}
					@if (items[1].text === 'resource-request-details') {
						<div class="staffing-link">
							<a
								href="https://msggroup.sharepoint.com/sites/TEA-Mitarbeitereinsatzplanung-MEP/SitePages/Dispo-Call-Informationen.aspx"
								target="_blank"
								><span>{{ _lang("info-page-dispo-call") }}</span></a
							>
						</div>
					}
				} @else {
					@if (authenticationService.hasUserRoles()) {
						<div>
							@if (
									this.authenticationService.hasMaSkillEditRole() ||
									this.authenticationService.hasMaSkillAndAssignmentEditRole()
							) {
								@if (item.text !== "/employee-list") {
									<a class="link" routerLink="{{ item.path }}">{{ _lang(item.text) }} {{ item.additionalText }}</a>
								} @else {
									<span class="link">{{ _lang(item.text) }} {{ item.additionalText }}</span>
								}
							} @else {
								<a class="link" routerLink="{{ item.path }}">{{ _lang(item.text) }} {{ item.additionalText }}</a>
							}
						</div>
					} @else {
						<a class="link" routerLink="{{ item.path }}">{{ _lang(item.text) }} {{ item.additionalText }}</a>
					}
					@if (item.text === '/resource-request-list' && items.length === 1) {
						<div class="staffing-link">
							<a
								href="https://msggroup.sharepoint.com/sites/TEA-Mitarbeitereinsatzplanung-MEP/SitePages/Dispo-Call-Informationen.aspx"
								target="_blank"
								><span>{{ _lang("info-page-dispo-call") }}</span></a
							>
						</div>
					}
				}
			}
		</mat-toolbar>
	}
}
